// @flow

import type { BoardSortOptionsType } from 'app/packages/pinterest-flow-types/user';

type BoardOrderProps = {
  hasCustomOrder: boolean,
  isOwnProfile: boolean,
  mostRecentBoardSortOrder: ?BoardSortOptionsType,
  updatedBoardOrder?: BoardSortOptionsType,
};

export default function getBoardOrder(props: BoardOrderProps): BoardSortOptionsType {
  const { hasCustomOrder, isOwnProfile, mostRecentBoardSortOrder, updatedBoardOrder } = props;
  // updatedBoardOrder: value from Redux that User recently selected from the BoardSortSelectlist
  if (isOwnProfile && updatedBoardOrder) {
    return updatedBoardOrder;
  }
  // mostRecentBoardSortOrder: Stored value on User metadata from last session where you made a selection
  if (mostRecentBoardSortOrder) {
    return mostRecentBoardSortOrder;
  }
  // Option for people who have never used the select list.
  return hasCustomOrder ? 'custom' : 'last_pinned_to';
}
